import { render, staticRenderFns } from "./SizeSelector.vue?vue&type=template&id=f972bf34&"
import script from "./SizeSelector.vue?vue&type=script&lang=js&"
export * from "./SizeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports